// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { Category } from "@insite/client-framework/Services/CategoryService";
import { BaseModel, PaginationModel } from "@insite/client-framework/Types/ApiModels";

const newsUrl = "/api/cmi/newslistings";

export interface GetNewsListApiParameter extends ApiParameter {
    page?: number;
    pageSize?: number;
    categories?: string;
}

export interface NewsListApiResult extends BaseModel {
    author: string;
    cardCategory: string;
    cardImage: string;
    cardSummary: string;
    date: string;
    title: string;
    url: string;
    id: string;
    subtitle: string;
}

export interface categoryFacet {
    categoryId: string;
    categoryName: string;
    count: number;
}

export interface NewsListCollectionApiResult extends BaseModel {
    categoryFacetModels: categoryFacet[];
    newsListings: NewsListApiResult[];
    paginationModel: PaginationModel;
}

export async function getNewsListService(parameter: GetNewsListApiParameter): Promise<NewsListCollectionApiResult> {
    const newsLists = await get<NewsListCollectionApiResult>(newsUrl, parameter);
    return newsLists;
}
